
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic17 as ObiHydraulic17Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-17.js';
 
 
 

 
 export const ObiHydraulic17 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-17',
   elementClass: ObiHydraulic17Element,
   events: {
     
   }
  });
 
 